jQuery(document).ready(function($) {

    // for events & posts

    if ($('.lyg-scrollable').length < 1) {
        return;
    }

    $('.scrollable__nav').click(function(e){
        e.preventDefault();
        var wrapper = $(e.target).parents('.lyg-scrollable').find('.lyg-scrollable__wrapper');
        var total = parseInt(wrapper.attr('data-total'));
        var current = parseInt(wrapper.attr('data-current'));
        var prev = current - 1;
        var next = current + 1;

        var prevBtn =  $(e.target).parent().find('.prev');
        var nextBtn = $(e.target).parent().find('.next');
      
        if ($(e.target).hasClass('prev')) {
            if (prev < 2) {                
                prevBtn.addClass('hide');
            } 
            if (current <= total) {
                nextBtn.removeClass('hide');
            } 

            if (current > 1) {
                wrapper.css('transform', 'translateX(-' + ((prev * 100) - 100) + '%)');
                wrapper.attr('data-current',prev);
            }
            
        } else if ($(e.target).hasClass('next')) {
            if (next === total) {
                nextBtn.addClass('hide');
            } 
            if (current > 0) {
                prevBtn.removeClass('hide');
            }

            if (next <= total) {
                wrapper.css('transform', 'translateX(-' + ((next * 100) - 100) + '%)');
                wrapper.attr('data-current',next);
            }
        }
    });

});